import script from "./RechargeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RechargeView.vue?vue&type=script&setup=true&lang=ts"

import "./RechargeView.vue?vue&type=style&index=0&id=19c88560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c88560"]])

export default __exports__